module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ASAP":"ASAP"},"id":{"ASAP":"ASAP"}}')
  delete Component.options._Ctor
}
